import size from 'lodash/size';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompact';

import { fetchOrderHistory } from 'src/app/state/actions';
import { accountLoadEverything } from 'src/app/state/actions/account';
import { bffFetchCart, loadCartDeliveryWindows, updateCartDeliveryMethod } from 'src/app/state/actions/cart';
import { pushNextCheckoutState } from 'src/app/state/actions/checkout';
import {
  getAccountIsFetching,
  getAllBFFOrders,
  getBFFCart,
  getBFFCartDeliveryWindowId,
  getCheckoutDeliveryWindows,
  getCheckoutDeliveryWindowsFetchError,
  getCheckoutDeliveryWindowsIsFetching,
  getCurrentAccountId,
  getCurrentCartId,
  getCurrentCartUUID,
  getIsBffCartFetching,
  getTierConsumerMessage,
} from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import type { UpdateCartDeliveryMethodRequest } from 'src/app/types';

import Renderer from '.';

function makeMapStateToProps() {
  return (state: RootState) => {
    const cartId = getCurrentCartId(state);
    const cartUUID = getCurrentCartUUID(state);
    const accountIsFetching = getAccountIsFetching(state);
    const bffCart = getBFFCart(state);
    const bffCartIsFetching = getIsBffCartFetching(state);
    const orders = getAllBFFOrders(state);
    const firstTimeOrder = size(orders) === 0;

    const checkoutDeliveryWindows = getCheckoutDeliveryWindows(state);
    const activeDeliveryWindowId = getBFFCartDeliveryWindowId(state);
    const tierConsumerMessage = getTierConsumerMessage(state);
    const isDeliveryWindowFetching = getCheckoutDeliveryWindowsIsFetching(state);
    const deliveryWindowFetchError = getCheckoutDeliveryWindowsFetchError(state);

    const accountId = getCurrentAccountId(state);

    return {
      accountId,
      accountIsFetching,
      cartId,
      cartUUID,
      bffCart,
      bffCartIsFetching,
      firstTimeOrder,
      activeDeliveryWindowId,
      checkoutDeliveryWindows,
      tierConsumerMessage,
      deliveryWindowFetchError,
      isDeliveryWindowFetching,
    };
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchLoadCart: cartId => dispatch(bffFetchCart(cartId)),
  dispatchUpdateCartAndPushNextCheckoutState: async (deliveryMethodBody: UpdateCartDeliveryMethodRequest) => {
    await dispatch(updateCartDeliveryMethod(deliveryMethodBody));
    await dispatch(pushNextCheckoutState());
  },
  dispatchGetOrderHistory: () => dispatch(fetchOrderHistory()),
  dispatchLoadAccountAndCartDeliveryWindows: async () => {
    await dispatch(accountLoadEverything());
    await dispatch(loadCartDeliveryWindows());
  },
});

const connector = connect(makeMapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default compose(setDisplayName('Checkout/DeliveryWindow/Select'), connector)(Renderer);
